"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmptyState = exports.EmptyStateLegacy = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../../../../shared/core");
var analytics_subjects_1 = require("../../../../analytics-subjects");
var meter_readings_1 = require("../../../../utils/meter-readings");
var supply_points_1 = require("../../../../utils/supply-points");
var EmptyHeader_1 = require("./EmptyHeader");
var EmptySummary_1 = require("./EmptySummary");
var EmptyStateLegacy = function (_a) {
    var _b;
    var supplyPointsInfo = _a.supplyPointsInfo, meterReadingsInfo = _a.meterReadingsInfo;
    var Stack = (0, core_1.useComponents)().Stack;
    var elecSupply = supplyPointsInfo.find(supply_points_1.isActiveElectricitySupply);
    var gasSupply = supplyPointsInfo.find(supply_points_1.isActiveGasSupply);
    var elecMeterType = (0, supply_points_1.getMeterType)(elecSupply);
    var gasMeterType = (0, supply_points_1.getMeterType)(gasSupply);
    var gasMeterReadings = meterReadingsInfo.gas;
    var elecMeterReadings = meterReadingsInfo.electricity;
    var hasTradMeter = (gasMeterType || elecMeterType) !== 'smart';
    var hasNonComm = (0, meter_readings_1.isNonComms)(gasMeterType === 'smart', gasMeterReadings) ||
        (0, meter_readings_1.isNonComms)(elecMeterType === 'smart', elecMeterReadings);
    return (react_1.default.createElement(ui_tools_1.AnalyticsView, { name: analytics_subjects_1.BILLING_DETAILS_CURRENT_EMPTY_PAGE, properties: (_b = {}, _b[core_1.INTERNAL_EVENT_FLAG] = true, _b) },
        react_1.default.createElement("section", null,
            react_1.default.createElement(Stack, { spaceBetween: [4, 8] },
                react_1.default.createElement(EmptyHeader_1.EmptyHeader, { hasTradMeter: hasTradMeter, hasNonComm: hasNonComm }),
                react_1.default.createElement(EmptySummary_1.EmptySummary, { hasTradMeter: hasTradMeter, hasNonComm: hasNonComm })))));
};
exports.EmptyStateLegacy = EmptyStateLegacy;
var EmptyState = function (_a) {
    var _b;
    var meterReadingsInfo = _a.meterReadingsInfo;
    var Stack = (0, core_1.useComponents)().Stack;
    var activeSupplies = meterReadingsInfo.electricity
        .concat(meterReadingsInfo.gas)
        .filter(function (supply) { return supply.states.isActive; });
    var hasTradMeter = activeSupplies.some(function (meter) { return !meter.states.isSmart; });
    var hasNonComm = activeSupplies.some(function (meter) { return meter.states.isNonComms; });
    return (react_1.default.createElement(ui_tools_1.AnalyticsView, { name: analytics_subjects_1.BILLING_DETAILS_CURRENT_EMPTY_PAGE, properties: (_b = {}, _b[core_1.INTERNAL_EVENT_FLAG] = true, _b) },
        react_1.default.createElement("section", null,
            react_1.default.createElement(Stack, { spaceBetween: [4, 8] },
                react_1.default.createElement(EmptyHeader_1.EmptyHeader, { hasTradMeter: hasTradMeter, hasNonComm: hasNonComm }),
                react_1.default.createElement(EmptySummary_1.EmptySummary, { hasTradMeter: hasTradMeter, hasNonComm: hasNonComm })))));
};
exports.EmptyState = EmptyState;
